import React, { useContext } from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import useFetch from "integrations/hooks/useFetch";
import { StatusIcon } from "components/common";
import Store from "logic/local-storage/Store";
import { ApiRoutes } from "./common/Routes";
import { toAWSCloudTrailInputCreateRequest } from "./common/formDataAdapter";
import FormWrap from "../common/FormWrap";
const Container = styled.div(
  ({ theme }) => css`
    border: 1px solid ${theme.colors.variant.darkest.default};
    margin: 25px 0;
    padding: 15px;
    border-radius: 4px;
    width: max-content;
  `
);
const Subheader = styled.h3`
  margin: 0 0 10px;
`;
const ReviewItems = styled.ul(
  ({ theme }) => css`
    list-style: none;
    margin: 0 0 25px 10px;
    padding: 0;

    li {
      line-height: 2;
      padding: 0 5px;

      &:nth-of-type(odd) {
        background-color: ${theme.colors.table.row.backgroundStriped};
      }
    }

    strong::after {
      content: ':';
      margin-right: 5px;
    }
  `
);
const StepReview = ({ onSubmit, externalInputSubmit = false }) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const { t } = useTranslation("integrations");
  const { formData } = useContext(FormDataContext);
  const throttleEnabled = !!((_a = formData.awsCloudTrailThrottleEnabled) == null ? void 0 : _a.value);
  const [saveInput, setSaveInput] = useFetch(
    null,
    (result) => {
      if (result == null ? void 0 : result.id) {
        Store.sessionSet("setup_wizard_input_id", result.id);
      }
      onSubmit();
    },
    "POST",
    toAWSCloudTrailInputCreateRequest(formData)
  );
  const formError = saveInput.error ? {
    full_message: saveInput.error,
    nice_message: /* @__PURE__ */ React.createElement("span", null, t("aws_cloudtrail_step_review.save_error"))
  } : null;
  const handleSubmit = () => {
    if (externalInputSubmit) {
      onSubmit(formData);
      return;
    }
    setSaveInput(ApiRoutes.INTEGRATIONS.AWSCloudTrail.SAVE_INPUT);
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("aws_cloudtrail_step_review.save_button"),
      loading: saveInput.loading,
      error: formError,
      description: t("aws_cloudtrail_step_review.description")
    },
    /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Subheader, null, t("aws_cloudtrail_step_review.input_configuration")), /* @__PURE__ */ React.createElement(ReviewItems, null, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, t("aws_cloudtrail_step_review.label_name")), /* @__PURE__ */ React.createElement("span", null, formData.awsCloudTrailName.value)), ((_b = formData.awsAccessKey) == null ? void 0 : _b.value) && /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, t("aws_cloudtrail_step_review.label_access_key")), /* @__PURE__ */ React.createElement("span", null, (_c = formData.awsAccessKey) == null ? void 0 : _c.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, t("aws_cloudtrail_step_review.label_sqs_region")), /* @__PURE__ */ React.createElement("span", null, formData.awsCloudTrailSqsRegion.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, t("aws_cloudtrail_step_review.label_s3_region")), /* @__PURE__ */ React.createElement("span", null, formData.awsCloudTrailS3Region.value)), ((_d = formData.awsAssumeRoleARN) == null ? void 0 : _d.value) && /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, t("aws_cloudtrail_step_review.label_assume_role_arn")), /* @__PURE__ */ React.createElement("span", null, (_e = formData.awsAssumeRoleARN) == null ? void 0 : _e.value)), ((_f = formData.awsExternalId) == null ? void 0 : _f.value) && /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, t("aws_cloudtrail_step_review.label_external_id")), /* @__PURE__ */ React.createElement("span", null, (_g = formData.awsExternalId) == null ? void 0 : _g.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, t("aws_cloudtrail_step_review.label_sqs_queue_name")), /* @__PURE__ */ React.createElement("span", null, (_h = formData.awsCloudTrailSqsQueueName) == null ? void 0 : _h.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, t("aws_cloudtrail_step_review.label_sqs_batch_size")), /* @__PURE__ */ React.createElement("span", null, (_i = formData.sqsMessageBatchSize) == null ? void 0 : _i.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, t("aws_cloudtrail_step_review.label_polling_interval")), /* @__PURE__ */ React.createElement("span", null, formData.pollingInterval.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, t("aws_cloudtrail_step_review.label_enable_throttling")), /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(StatusIcon, { active: throttleEnabled })))))
  );
};
export default StepReview;
